import React, { useState, useEffect } from 'react'
import { graphql, Link } from 'gatsby'
import Button from './Button'
import { initGtm, handlePageView } from '../services/GoogleTagManager';
import { RichText } from 'prismic-reactjs'
import linkResolver from '../utils/linkResolver'

const CookiesNotice = ({ data, location }) => {

	const [isOpen, setIsOpen] = useState(true)

	useEffect(() => {
		const showCookiesNotice = localStorage.getItem('showCookiesNotice')
		setIsOpen(showCookiesNotice ? !showCookiesNotice : true)
	}, [])

	const handleDecline = () => {
		setIsOpen(false)
		localStorage.setItem('showCookiesNotice', false)
		localStorage.setItem('areCookiesAgreed', false)
	}

	const handleAccept = () => {
		setIsOpen(false)
		localStorage.setItem('showCookiesNotice', false)
		localStorage.setItem('areCookiesAgreed', true)
		initGtm()
		handlePageView(location)
	}

	return (
		<div className={`CookiesNotice ${isOpen ? 'isOpen' : ''}`}>
			<div className="CookiesNotice__Left">
				<p className="CookiesNotice__Title">
					{data.title.text}
				</p>
				<div className="CookiesNotice__Text">
					<RichText render={data.text.richText} linkResolver={linkResolver}/>
				</div>
				<div className="CookiesNotice__Deline" onClick={handleDecline}>
					<p className="CookiesNotice__DelineText">{data.decline_text.text}</p>
					<svg className="CookiesNotice__DelineArrow" viewBox="0 0 27 20"><g strokeWidth="2" fill="none" fillRule="evenodd"><path d="M.463 9.395h23.929L17 .79M24.392 9.395 17 18.847"/></g></svg>
				</div>
			</div>
			<div className="CookiesNotice__Accept" onClick={handleAccept}>
				<svg className="CookiesNotice__AcceptArrow" viewBox="0 0 31 23"><path strokeWidth="3" d="m1.769 13.565 7.515 6.976L29.999 1.623" fill="none" fillRule="evenodd"/></svg>
			</div>
		</div>
	)
}

export default CookiesNotice

export const query = graphql`
	fragment CookiesNotice on PrismicCookiesNotice {
		data {
			title {
				text
			}
			text {
				richText
			}
			decline_text {
				text
			}
		}
	}
`